const { NODE_ENV } = process.env;
// апи
export const BACKEND_API_URL =
    NODE_ENV === 'development'
        ? 'https://hr.proway.tech/integrations/sb_anketa'
        : 'https://hr.proway.tech/integrations/sb_anketa';
// куда редирект после отправки
export const pageToRedirect = 'https://proway.tech/';
// персональные данные
export const personalData = 'https://proway.tech/privacy-policy';
